import DOMPurify from 'dompurify';

const removeEmojis = (str) =>
  str.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|[\u2011-\u26FF])/g,
    ''
  );

const sanitizeValues = (values) => {
  if (typeof values === 'string') {
    const noEmojis = removeEmojis(values);
    const clean = DOMPurify.sanitize(noEmojis, { ALLOWED_TAGS: [] }).trim();
    return clean; // Return the sanitized string (empty strings are preserved)
  } else if (Array.isArray(values)) {
    // const sanitizedArray = values.map(sanitizeValues);
    return values.map(sanitizeValues); // Do not filter out empty strings or null
  } else if (typeof values === 'object' && values !== null) {
    const sanitized = {};
    Object.keys(values).forEach((key) => {
      sanitized[key] = sanitizeValues(values[key]);
    });
    return sanitized;
  }
  return values; // Return other types as-is
};

export default sanitizeValues;
